'use strict';

function DashboardAccount() {
  var _this2 = this;

  this.node = null;
  this.$node = null;
  this.id = null;
  this.declaredClass = null;
  this.extends = [];
  this.notifications = null;

  this._modelsMarkedForDeletion = {};

  this.init = function () {
    this.analytics.pushEvent('virtual-page-view');
    this.$node = $(this.node);

    this.notifications = $('#Notification');

    this._phoneNumbers = new PhoneNumbers(this.presenter);

    this._browserlanguage = navigator.language || navigator.userLanguage;
    this._usrLanguage = this._browserlanguage.toLowerCase();

    // Setup Trusted Devices
    if (this.$node.find('.dashboard-account-devices')[0]) {
      this.$node.find('.dashboard-account-devices')[0].mogo().create('DashboardAccountDevices', {
        presenter: this.presenter,
        analytics: this.analytics
      }, 'page');
    }

    // Setup Timezone Section
    this._setupTimeZone();

    this._legalDisclaimer();

    // Debuggin:
    if (window.mogo.registry.mogoUI.config._ui_debug) {
      this.presenter.setModelProperty('account._ui_debug', 1);
    }
  };

  this.initAllReady = function () {
    var _this = this;

    this.presenter.addComputedVariable('showFrenchLanguage', ['account.province'], function (province) {
      if ((_this._usrLanguage === 'fr' || _this._usrLanguage === 'fr-fr' || _this._usrLanguage === 'fr-ca') && province === 'QC') {
        return true;
      }
      return false;
    });

    this.presenter.addComputedVariable('fullName', ['account.first_name', 'account.last_name'], function (firstName, lastName) {
      return firstName + ' ' + lastName;
    });

    this.presenter.addComputedVariable('address_line_one', ['account.suite', 'account.address'], function (suite, address) {
      var suiteFormatted = suite ? '#' + suite + ' - ' : '';
      return suiteFormatted + address;
    });

    this.presenter.addComputedVariable('address_line_two', ['account.city', 'account.province', 'account.postal_code'], function (city, province, postal_code) {
      return city + ', ' + province + ' - ' + postal_code;
    });

    this.presenter.addComputedVariable('pending_address_line_one', ['account.pending_address'], function (pending_address) {
      var suiteFormatted = pending_address.suite ? '#' + pending_address.suite + ' - ' : '';
      return suiteFormatted + pending_address.address;
    });

    this.presenter.addComputedVariable('pending_address_line_two', ['account.pending_address'], function (pending_address) {
      return pending_address.city + ', ' + pending_address.province + ' - ' + pending_address.postal_code;
    });

    this.presenter.addComputedVariable('has_pending_address', ['account'], function () {
      return _this._hasPendingAddress() !== undefined;
    });

    this.presenter.addComputedVariable('can_edit_address', ['account'], function () {
      return _this._hasPendingAddress() === undefined;
    });

    this.presenter.addComputedVariable('has_address_in_new_format', ['account'], function () {
      return _this._hasAddressInNewFormat() === true;
    });
  };

  this._hasPendingAddress = function () {
    return _this2.presenter.getModelProperty('account.pending_address');
  };

  // New address format - https://mogofintech.atlassian.net/browse/ACCT-596
  this._hasAddressInNewFormat = function () {
    var newAddressArray = _this2.presenter.getModelProperty('account.addresses');

    if (!newAddressArray) return false;

    var addressList = newAddressArray.filter(function (address) {
      return address.type === 'residential';
    });

    if (addressList && addressList.length > 0) {
      return true;
    }
    return false;
  };

  this._legalDisclaimer = function () {
    $('.js--legal-disclaimer', this.node).mogo().create('LegalDisclaimer', {
      otherLegal: ['disclaimer.mogoCorporateStandard', 'disclaimer.visaStandard', 'disclaimer.appleTrademarkLogos', 'disclaimer.googlePlayTrademarkLogos', 'disclaimer.equifaxTrademark'],
      presenter: this.presenter,
      showCta: true
    });
  };

  /* ~~~ Time Zone ~~~ */

  this._changeTimeZoneState = function (isEditing) {
    var $editing = this.$node.find('.js--editing-timezone');
    var $viewing = this.$node.find('.js--viewing-timezone');

    if (isEditing) {
      $editing.show();
      $viewing.hide();
    } else {
      $editing.hide();
      $viewing.show();
      this.presenter.resetModels('account');
    }
  };

  this._setupTimeZone = function () {
    var _this3 = this;

    this._getTimeZones();
    this.presenter.addCallbackToAction('account.edit_timezone', this._editTimeZone.bind(this));

    if (typeof this.presenter.getModelProperty('account.timezone') === 'undefined') {
      this._changeTimeZoneState(true);
    } else {
      this._changeTimeZoneState(false);
    }

    this.$node.find('.js--timezone-edit-link').on('click', function (e) {
      e.preventDefault();
      _this3._changeTimeZoneState(true);
    });

    this.$node.find('.js--timezone-cancel-link').on('click', function (e) {
      e.preventDefault();
      if (typeof _this3.presenter.getModelProperty('account.timezone') !== 'undefined') {
        _this3._changeTimeZoneState(false);
      }
    });
  };

  this._updateTimeZoneSelect = function (data) {
    var $select = this.$node.find('.js--timezone-select');

    if ($select.length > 0 && data !== null && data.hasOwnProperty('timezones')) {
      for (var i = 0; i < data.timezones.length; i++) {
        var timezone = data.timezones[i];
        $select.mogo().addOption(timezone.label, timezone.value);
      }
    }

    this.presenter.updateDOM();
  };

  this._getTimeZones = function () {
    this.presenter.createModel('timezones', { uri: '/timezones' }, this._updateTimeZoneSelect.bind(this));
  };

  this._onTimeZoneSuccess = function (data) {
    this.presenter.updateModel('account', data);
    this._changeTimeZoneState(false);

    // HACK: This should be replaced with proper model management later. eg: requireModel / setAllModelsAsOutdated
    for (var model in this.presenter.models) {
      if (this.presenter.models.hasOwnProperty(model)) {
        if (model !== 'account' && model !== 'authenticatedDevices') {
          if (this.presenter.hasAction(model + '.self')) {
            this.presenter.updateModel(model);
          } else {
            this._modelsMarkedForDeletion[model] = true;
          }
        }
      }
    }

    this.notifications.mogo().create({
      type: 'success',
      msg: 'Your time zone has been successfully updated'
    });
  };

  this._onTimeZoneFailure = function () {
    this._changeTimeZoneState(true);

    this.notifications.mogo().create({
      type: 'error',
      msg: 'Bugger, something went wrong with changing your time zone. Try again?'
    });
  };

  this._editTimeZone = function (data, response) {
    if (response == 200) {
      this._onTimeZoneSuccess(data);
    } else {
      this._onTimeZoneFailure();
    }
  };

  this.destroy = function () {
    this.presenter.removeComputedVariable('fullName');
    this.presenter.removeComputedVariable('phone_number');
    this.presenter.removeComputedVariable('address_line_one');
    this.presenter.removeComputedVariable('address_line_two');
    this.presenter.removeComputedVariable('pending_address_line_one');
    this.presenter.removeComputedVariable('pending_address_line_two');
    this.presenter.removeComputedVariable('has_pending_address');
    this.presenter.removeComputedVariable('can_edit_address');
    this.presenter.removeComputedVariable('has_address_in_new_format');

    $('#consent-toggle', this.node).off('click.toggleConsent');

    this._phoneNumbers.destroyClass();

    for (var key in this._modelsMarkedForDeletion) {
      delete this.presenter.models[key];
    }
  };
}